// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"797":"c767abab","847":"fba73c84"}[chunkId] + ".chunk.css";
};